import './editor-page-layout.scss';

import EditorPageToolbar, { EditorPageToolbarProps } from './editor-page-toolbar/editor-page-toolbar';

interface EditorPageLayoutProps {
    toolbar?: EditorPageToolbarProps,
    children: React.ReactNode;
}

const EditorPageLayout = ({ toolbar, children }: EditorPageLayoutProps) => (
    <div className="editor-page">
        {toolbar && <EditorPageToolbar {...toolbar} />}

        <div className="editor-page-content">
            {children}
        </div>
    </div>
);

export default EditorPageLayout;
